import { TextButton, Page, Typography } from 'components'
import {
  LogoImageStyled,
  WrapperTitlePageStyled,
  WrapperContentStyled,
  ErrorImageStyled,
  WrapperSubTitlePageStyled,
  WrapperContentTextStyled
} from './styles'
import ImageError from 'assets/png/error/hav_error.png'
import ImageLogo from 'assets/png/error/hav_logo.png'

function Error() {
  return (
    <Page hasHeader={false}>
      <WrapperContentStyled>
        <LogoImageStyled src={ImageLogo} alt="Logo Havaianas" />
        <WrapperTitlePageStyled>
          <Typography design="hav-default-01-text" variant="h1">
            Ops! Página não encontrada
          </Typography>
        </WrapperTitlePageStyled>
        <ErrorImageStyled src={ImageError} alt="Erro ao carregar a página" />
        <WrapperSubTitlePageStyled>
          <Typography design="hav-default-01-text" variant="h2">
            O que pode ter acontecido?
          </Typography>
        </WrapperSubTitlePageStyled>
        <WrapperContentTextStyled>
          O conteúdo não está mais disponível ou você digitou o endereço errado.
        </WrapperContentTextStyled>
        <WrapperContentTextStyled>
          <TextButton url="/">Clique aqui</TextButton> e volte para a Página Inicial.
        </WrapperContentTextStyled>
      </WrapperContentStyled>
    </Page>
  )
}

export default Error
